module.exports = "/static/img/we_work_with_1.svg?542cfac4a95117e494d5edc16153d2c7";